import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfigModel, ConfigRTCModel, MqttSettingsModel, CsvHeaderModel } from 'src/app/Model/IConfiguration';
import { AuthService } from 'src/app/service/auth.service';
import { GSMConfigurationService } from 'src/app/Service/gsmconfiguration.service';
import { MQTTOperation } from 'src/app/Service/mqttoperation.service';
import { GenericValidator } from 'src/app/validation/general-validation';
import { DatePipe, formatDate } from '@angular/common';
import { CommonService } from '../../service/common.service';
import * as moment from 'moment';
import { ReportService } from 'src/app/service/report.service';


@Component({
    selector: 'app-schedulereport',
    templateUrl: './schedulereport.html'
})
export class SchedulereportComponent implements OnInit {
    isfromEdit: boolean = false;
    CompanyIdforUC: number = 0;
    DeviceType: string = '';
    scheduleform: FormGroup;
    errorMsg: any;
    UserId: number = 0;
    CompanyList: [];
    SiteList: any[] = [];
    PanelList: [];
    ScheduleData: [];
    EnergymeterList: any[];
    SiteId: string = '';
    PanelId: string = '';
    MeterId: string = '';
    SiteName: string = '';
    CompanyId: string = '';
    CompanyName: string = '';
    PanelName: string = '';
    EnergymeterName: string = '';
    displayMessage: { [key: string]: string } = {};
    private genericValidator: GenericValidator;
    private validationMessages: { [key: string]: { [key: string]: string } };
    successMsg: string = '';

    constructor(public datepipe: DatePipe, private authService: AuthService, private reportservice: ReportService, private commonservice: CommonService, private form: FormBuilder, private dialog: MatDialog, private mqttoperation: MQTTOperation, public dialogRef: MatDialogRef<SchedulereportComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        dialogRef.disableClose = true;
        // Raise Validation message
        this.authService.getValidationMessage().subscribe(resp => {
            this.validationMessages = resp.scheduleform;
            this.genericValidator = new GenericValidator(this.validationMessages);
        });
    }
    ngOnInit(): void {
        this.CompanyIdforUC = +localStorage.getItem('CompanyIdForUC');
        this.UserId = +localStorage.getItem('UserId');
        this.scheduleform = this.form.group({
            ScheduleReportId: [],
            CompanyId: ['', [Validators.required]],
            SiteId: ['', [Validators.required]],
            PanelId: ['', [Validators.required]],
            MeterId: ['', Validators.required],
            IsDaily: [false],
            IsWeekly: [false],
            IsMonthly: [false],
            IsYearly: [false]
        });

        this.scheduleform.patchValue({
            CompanyId: this.CompanyIdforUC,
        });
        this.OnChangeCompany(this.CompanyIdforUC);
        this.GetSheduleData();
    }
    // Mayank - To fill data on click
    fillSheduleData(schedule) {
        this.errorMsg = '';
        this.successMsg = '';
        this.isfromEdit = true;
        this.GetSiteList(schedule.CompanyId);
        this.GetPanelList(schedule.SiteId);
        this.GetEnergymeterList(schedule.SiteId, schedule.PanelId);
        this.scheduleform.patchValue({
            ScheduleReportId: schedule.ScheduleReportId,
            CompanyId: schedule.CompanyId,
            SiteId: schedule.SiteId.toString(),
            PanelId: schedule.PanelId.toString(),
            MeterId: schedule.MeterId,
            IsDaily: schedule.IsDaily == 'N' ? false : true,
            IsWeekly: schedule.IsWeekly == 'N' ? false : true,
            IsMonthly: schedule.IsMonthly == 'N' ? false : true,
            IsYearly: schedule.IsYearly == 'N' ? false : true
        });
        this.scheduleform.updateValueAndValidity(); // Update the values for all fields
    }
    GetSheduleData() {
        this.ScheduleData = [];
        this.reportservice.GetSheduleData(this.UserId).subscribe((result) => {
            if (result) {
                result.forEach((element, i) => {
                    this.ScheduleData = result;
                    this.CompanyId = result[i].CompanyId;
                    this.SiteId = result[i].SiteId;
                    this.PanelId = result[i].PanelId;
                });
            }
            else {
                this.resetform();
            }
        },
        );
    }

    OnSubmitScheduleReport() {
        this.errorMsg = '';
        this.successMsg = '';
        if (this.scheduleform.invalid) {
            this.scheduleform.updateValueAndValidity();
            this.displayMessage = this.genericValidator.processMessages(this.scheduleform, true);
            return;
        }

        if (this.scheduleform.value.IsDaily == false && this.scheduleform.value.IsWeekly == false && this.scheduleform.value.IsMonthly == false && this.scheduleform.value.IsYearly == false && this.isfromEdit == false) {
            this.errorMsg = 'At least one checkbox is required to check.';
            return;
        }
      var reqparam = { ...this.scheduleform.value };

      let ReqObj =
        {
            ScheduleReportId: reqparam.ScheduleReportId ? reqparam.ScheduleReportId : 0,
            UserId: this.UserId,
            CompanyId: reqparam.CompanyId,
            SiteId: reqparam.SiteId,
            PanelId: reqparam.PanelId,
            MeterId: reqparam.MeterId,
            IsDaily: reqparam.IsDaily ? 'Y' : 'N',
            IsWeekly: reqparam.IsWeekly ? 'Y' : 'N',
            IsMonthly: reqparam.IsMonthly ? 'Y' : 'N',
            IsYearly: reqparam.IsYearly ? 'Y' : 'N'
        };

        this.reportservice.saveSchedule(ReqObj).subscribe(
            (result) => {
                if (result) {
                    this.successMsg = 'Values Submitted Successfully';
                      this.displayMessage = this.genericValidator.processMessages(this.scheduleform, false)
                    this.isfromEdit = false;
                    this.GetSheduleData();
                }
            },
            (error) => {
                this.errorMsg = error;
            });
    }

    // Mayank
    resetform() {
        this.scheduleform = this.form.group({
            CompanyId: ['', [Validators.required]],
            SiteId: ['', [Validators.required]],
            PanelId: ['', [Validators.required]],
            MeterId: ['', Validators.required],
            IsDaily: [false],
            IsWeekly: [false],
            IsMonthly: [false],
            IsYearly: [false]
        });
    }

    // Called on change Panel
    OnChangePanel(event) {
        this.scheduleform.patchValue({
            PanelId: event.value
        });

        this.PanelId = event.value;
        this.PanelName = event.source.triggerValue;
        this.GetEnergymeterList(this.SiteId, this.PanelId);
        this.scheduleform.patchValue({
            MeterId: ''
        });
    }

    // Called on chenge Energymeter
    OnChangeEnergymeter(event) {
        this.scheduleform.patchValue({
            MeterId: event.value
        });
        this.MeterId = event.value;
        this.EnergymeterName = event.source.triggerValue;
    }

    // Called on change Company
    OnChangeCompany(companyId) {
        this.GetSiteList(companyId);
        this.scheduleform.patchValue({
            SiteId: '',
            PanelId: ''
        });
    }

    // Called on change Site
    OnChangeSite(event) {
        this.scheduleform.patchValue({
            SiteId: event.value
        });
        this.SiteId = event.value;
        this.SiteName = event.source.triggerValue;
        this.GetPanelList(event.value);
        this.GetEnergymeterList(this.SiteId, 0);
        this.scheduleform.patchValue({
            PanelId: '',
            MeterId: ''
        });
    }

    // Get Site List
    GetSiteList(CompanyId) {
        this.commonservice.GetSiteList(CompanyId).subscribe(
            (result) => {
                this.SiteList = result;
            },
            (error) => {
                this.errorMsg = error;
            }
        );
    }

    // Get Panel List
    GetPanelList(SiteId) {
        this.commonservice.GetPanelList(SiteId).subscribe(
            (result) => {
                this.PanelList = result;
            },
            (error) => {
                this.errorMsg = error;
            }
        );
    }
    // Get Energy meter List
    GetEnergymeterList(SiteId, PanelId) {
        this.commonservice.GetEnergyMeterIdList(SiteId, PanelId, 'N').subscribe(
            (result) => {
                if (result.length > 0) {
                    this.EnergymeterList = result;
                }
            },
            (error) => {
                this.errorMsg = error;

            }
        );
    }

    Close() {
        this.dialogRef.close();
    }
    Cancel() {
        this.dialogRef.close();
    }
}
